import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input"];
  
  connect() {
    this.currentRating = 0;
    this.updateStars();
  }

  handleStarClick(event) {
    const starElement = event.currentTarget;
    const starLabel = starElement.closest('.star-label');
    const index = parseInt(starLabel.dataset.index);
    const isLeftHalf = starElement.classList.contains('left');
    
    this.currentRating = isLeftHalf ? index + 0.5 : index + 1;
    
    this.updateStars();
    this.inputTarget.value = this.currentRating;
    
    const ratingValue = document.getElementById('minRatingValue');
    if (ratingValue) {
      ratingValue.textContent = this.currentRating.toFixed(1);
    }
  }

  updateStars() {
    const starLabels = this.element.querySelectorAll('.star-label');
    
    starLabels.forEach((label, index) => {
      const leftPath = label.querySelector('.star.half.left path');
      const rightPath = label.querySelector('.star.half.right path');
      
      if (index < Math.floor(this.currentRating)) {
        // Full star
        leftPath.setAttribute('fill', '#ffd700');
        rightPath.setAttribute('fill', '#ffd700');
      } else if (index === Math.floor(this.currentRating)) {
        if (this.currentRating % 1 === 0.5) {
          // Half star
          leftPath.setAttribute('fill', '#ffd700');
          rightPath.setAttribute('fill', '#ccc');
        } else {
          // Empty star
          leftPath.setAttribute('fill', '#ccc');
          rightPath.setAttribute('fill', '#ccc');
        }
      } else {
        // Empty star
        leftPath.setAttribute('fill', '#ccc');
        rightPath.setAttribute('fill', '#ccc');
      }
    });
  }
}